import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=4add83a6&scoped=true"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add83a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4add83a6')) {
      api.createRecord('4add83a6', component.options)
    } else {
      api.reload('4add83a6', component.options)
    }
    module.hot.accept("./Restore.vue?vue&type=template&id=4add83a6&scoped=true", function () {
      api.rerender('4add83a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/auth/components/Restore.vue"
export default component.exports